
export interface Timezone {
    name: string;
    code: string;
}

const BuildTimezone = (name: string, code: string) => {
    return { name, code };
};

export const Timezones: Array<Timezone> = [
    BuildTimezone("Pacific", "America/Vancouver"),
    BuildTimezone("Mountain", "America/Edmonton"),
    BuildTimezone("Central (SK)", "America/Regina"),
    BuildTimezone("Central (MB)", "America/Winnipeg"),
    BuildTimezone("Eastern", "America/Toronto"),
    BuildTimezone("Atlantic", "America/Halifax")
];

export const DefaultTimezone: string = "America/Toronto";

export const InterpretTimezoneCode: Function = (code: string): string => (Timezones.filter(t => t.code === code)[0] || {name: ""}).name;
